import { useState } from "react";
import { useAuth } from "../utils/auth";
import "../css/gebruikerInstellingen.css";
import { VscEdit } from 'react-icons/vsc';
import { MdOutlineCancel } from 'react-icons/md';
import PasswordChange from "../modules/Gebruikerinstellingen/PasswordChange";


const GebruikerInstellingen = () => {

    const auth = useAuth();
    const gebruikersnaam = auth.user.gebruikersnaam;
    const loginemail = auth.user.loginemail;
    const info = auth.user.info;
    const voornaam = auth.user.voornaam;
    const tussenvoegsel = auth.user.tussenvoegsel;
    const achternaam = auth.user.achternaam;
    const _id = auth.user._id;
    const contactemail = auth.user.contactemail;

    const initialformData = {
        gebruikersnaam,
        loginemail,
        info,
        voornaam,
        tussenvoegsel,
        achternaam, 
        contactemail
    }

    const initialShowInputFields = {
        gebruikersnaam: false,
        loginemail: false,
        info: false,
        voornaam: false,
        tussenvoegsel: false,
        achternaam: false,
        contactemail: false
    }

    const [formdata, setFormData] = useState(initialformData);
    const [message, setMessage] = useState("");
    const [showInputFields, setShowInputFields] = useState(initialShowInputFields);
    const [hasEdit, setHasEdit] = useState(false);


    const handleToggleInput = (e) => {
        const keyX = e.target.name;
        const currentValue = showInputFields[keyX];
        setShowInputFields({
            ...showInputFields,
            [keyX]: !currentValue
        });
        setFormData({
            ...formdata,
            [e.target.name]: initialformData[e.target.name]
        })
    }

    const handleChange = (e) => {
        const key = e.target.name;
        setFormData({
            ...formdata,
            [key]: e.target.value
        });
        setHasEdit(true);
        setMessage("");
    }

    const handleSubmit = async () => {
        setMessage("");
        const data = {
            method: 'PATCH',
            path: `auth/${_id}/update`,
            input: formdata
        }
        const result = await auth.update(data);
        setMessage(result.message);
        setShowInputFields(initialShowInputFields);
        setHasEdit(false);
        
    }


    return (
        <div className="accountInstellingen">
            <h2>Account instellingen</h2>
            <div className="instellingenContainer">
                <div className="accountItem">
                    <div className="data">
                        <span className="title">Gebruikersnaam:</span>
                        <span className="gegevens">{gebruikersnaam}</span>
                        <button
                            name="gebruikersnaam"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.gebruikersnaam ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.gebruikersnaam &&
                            <input 
                                type="text" 
                                name="gebruikersnaam"
                                value={formdata.gebruikersnaam}
                                onChange={handleChange}
                            />
                        }
                    </div>
                    <div className="info">
                        <p>Je gebruikersnaam is zichtbaar voor overige gebruikers als je je voor een vrijwilligerstaak hebt aangemeld.</p>
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">Loginemail:</span>
                        <span className="gegevens">{loginemail}</span>
                        <button
                            name="loginemail"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.loginemail ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.loginemail &&
                            <input 
                                type="text" 
                                name="loginemail"
                                value={formdata.loginemail}
                                onChange={handleChange}
                            />
                        }
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">Extra info:</span>
                        <span className="gegevens">{info}</span>
                        <button
                            name="info"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.info ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.info &&

                        <textarea 
                            name="info" 
                            cols="50" 
                            rows="5"
                            onChange={handleChange}
                            value={formdata.info}
                        >
                            
                        </textarea>
                        }
                    </div>
                    <div className="info">
                        <p>Je kunt hier bijvoorbeeld vermelden dat je geen lid bent en een account hebt als ouder/verzorgen van een minderjarig lid (naam graag vermelden). Deze extra info is alleen zichtbaar voor contactpersonen/activiteitencommissie/bestuur. </p>
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">Voornaam:</span>
                        <span className="gegevens">{voornaam}</span>
                        <button
                            name="voornaam"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.voornaam ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.voornaam &&
                            <input 
                                type="text" 
                                name="voornaam"
                                value={formdata.voornaam}
                                onChange={handleChange}
                            />
                        }
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">Tussenvoegsel:</span>
                        <span className="gegevens">{tussenvoegsel}</span>
                        <button
                            name="tussenvoegsel"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.tussenvoegsel ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.tussenvoegsel &&
                            <input 
                                type="text" 
                                name="tussenvoegsel"
                                value={formdata.tussenvoegsel}
                                onChange={handleChange}
                            />
                        }
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">Achternaam:</span>
                        <span className="gegevens">{achternaam}</span>
                        <button
                            name="achternaam"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.achternaam ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.achternaam &&
                            <input 
                                type="text" 
                                name="achternaam"
                                value={formdata.achternaam}
                                onChange={handleChange}
                            />
                        }
                    </div>
                </div>

                <div className="accountItem">
                    <div className="data">
                        <span className="title">contactemail:</span>
                        <span className="gegevens">{contactemail}</span>
                        <button
                            name="contactemail"
                            onClick={handleToggleInput}
                        >
                            {showInputFields.contactemail ? <MdOutlineCancel className="cancel"/> : <VscEdit /> }
                            
                        </button>
                    </div>
                    <div className="input">
                        { showInputFields.contactemail &&
                            <input 
                                type="text" 
                                name="contactemail"
                                value={formdata.contactemail}
                                onChange={handleChange}
                            />
                        }
                    </div>
                    <div className="info">
                        <p>Als je een ander email adres will gebruiken voor contact dan je loginemail, kun je hier een alternatief email adres invoegen. </p>
                    </div>
                </div>

                <div className="accountItem">
                {hasEdit &&
                    <div className="data">
                        <span className="title">Bevestig wijzigingen:</span>
                        <span>
                            
                        <button className="button bevestig" onClick={handleSubmit}>Bevestig</button>
                        </span>
                    </div>
                }
                    <div className="info message">
                        {message}
                    </div>
                </div>
                <div>
                    <PasswordChange 
                        setMessage={setMessage}
                        loginemail={loginemail}
                    />
                </div>
                
            </div>
        </div>
    );
}

export default GebruikerInstellingen;